import { isValidString } from "src/Library/Helper";
import isEmpty from "lodash/isEmpty";

const OnboardingStepsMap = {
  IMPORTER_BASIC_SETTINGS: 0,
  ADD_DESTUFFING_ADDRESS_ON_MAP: 1,
  ADD_DESTUFFING_ADDRESS_FORM: 2,
  EXPORTER_BASIC_SETTINGS: 3,
  ADD_STUFFING_ADDRESS_ON_MAP: 4,
  ADD_STUFFING_ADDRESS_FORM: 5,
};

const accessorTypes = {
  PUBLIC: 'Everyone',
  PRIVATE: 'My Team',
  CUSTOM: 'My Team & Organisation',
};

const getFormattedAddress = (address) => {
  if (isEmpty(address)) return;
  return [
    address.address,
    address.landmark,
    (address.city && address.pincode) ? `${address.city} - ${address.pincode}` :
    (address.city ? address.city : address.pincode),
    address.state,
    address.countryName,
  ].filter(item => isValidString(item))?.join(', ');
};

export {
  OnboardingStepsMap,
  accessorTypes,
  getFormattedAddress,
};